<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/customer">客户管理</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>客户跟进</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item label="客户">
          <el-select
            v-model="query.cusID"
            clearable
            filterable
            placeholder="请选择客户"
            @change="selList()"
          >
            <el-option
              v-for="item in cuslist"
              :label="item.nickName"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="addClick();">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>资源跟进列表</span>
        </div>

        <el-tabs v-model="query.state" @tab-click="getList();">
         
          <el-tab-pane
            v-for="item in statelist"
            :label="item.name"
            :key="item.id"
            :name="item.id.toString()"
          ></el-tab-pane>
        </el-tabs>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="cusName" label="客户昵称"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="title" label="跟进主题"></el-table-column>
          <el-table-column prop="summary" label="跟进说明"></el-table-column>
          <el-table-column label="跟进状态">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.state==1">{{scope.row.stateName}}</el-tag>
              <el-tag type="info" v-else-if="scope.row.state==2">{{scope.row.stateName}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="nextDate" label="下次回访时间"></el-table-column>
          <el-table-column prop="nextSubject" label="下次回访主题"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑客户跟进':'添加客户跟进'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="cusID" label="客户" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.cusID" clearable filterable placeholder="请选择客户">
                <el-option
                  v-for="item in cuslist"
                  :label="item.nickName"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户状态" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.cusState" clearable placeholder="请选择状态">
                <el-option
                  v-for="item in cusStateList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="title" label="跟进主题" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.title" placeholder="请输入跟进主题"></el-input>
        </el-form-item>

        <el-form-item prop="summary" label="跟进说明">
          <el-input v-model="form.summary" placeholder="请输入跟进说明"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="state" :rules="[{required:true,message:'请选择跟进状态'}]">
              <el-select v-model="form.state" clearable placeholder="请选择跟进状态" filterable>
                <el-option
                  v-for="item in statelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="回访时间" prop="nextDate">
          <el-date-picker
            v-model="form.nextDate"
            value-format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择下次回访时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="nextSubject" label="回访主题">
          <el-input v-model="form.nextSubject" placeholder="请输入回访主题"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
 
      query: {
        state: "1",
      },
      form: {},
      submiting: false,
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      statelist: [
        { id: 1, name: "待处理" },
        { id: 2, name: "已处理" },
        { id: 0, name: "全部" },
      ], //状态
      cuslist: [], //客户信息
      cusStateList: [], //状态
    };
  },
  methods: {
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.currentPage4 = val;
      this.getList();
    },
    //   排序
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 客户列表
    getCusList: function () {
      var _this = this;
      var link = url.getCrm("getall_customer");
      $.get(link, {}, (data) => {
        _this.cuslist = data;
      });

      var link = url.getCrm("getcustomerstate");
      $.get(link, {}, (data) => {
        _this.cusStateList = data;
      });
    },
    // 列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      if (_this.cusid) {
        var cusid = _this.cusid;
        params.cusID = parseInt(cusid);
      }
      var link = url.getCrm("getlist_follow");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 新增
    addClick: function () {
      this.dialogVisible = true;
      if (this.cusid) {
        var cusid = this.cusid;
        //获取客户状态
        var temp = this.cuslist.find((q) => q.id == cusid);
        var cusState = 0;
        if (temp) {
          cusState = temp.state;
        }
        this.form = { cusID: parseInt(cusid), cusState: cusState };
      } else {
        this.form = {};
      }
    },
    // 编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      if (typeof this.form.nextDate === "string") {
        this.form.nextDate = new Date(this.form.nextDate);
      }
      this.dialogVisible = true;
    },
    // 删除
    delClick: function (row) {
      var _this = this;
      var id = row.id;
      var link = url.getJap("delete_follow");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.submiting = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var info = _this.form;
      var link = url.getCrm("save_follow");
      if (_this.cusid) {
        var cusid = _this.cusid;
        info.cusID = parseInt(cusid);
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    var _this = this;
    //   接收参数

    _this.query.cusID=this.$route.params.id;
    if (this.cusID > 0) {
      this.getList();
    } else {
      _this.form = {};
    }
    // 客户列表
    this.getCusList();
    // 列表
    _this.getList();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>